import { Guid } from "@/Common/Models/Guid";
import { TreeNodeTarget } from "@/Common/Models/UI/Enums";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";

interface ITreeNodeProps {
    key?: any;
    componentId?: string;
    className?: string;
    childNodes?: Immutable.List<TreeNode>;
    text: string;
    isSelected: boolean;
    isExpanded: boolean;
    childClickTarget?: TreeNodeTarget;
    parentClickTarget?: TreeNodeTarget;
    parentClickOperation?: number;
    referencedObject?: any;
    lookupId: Guid | string;
}

class TreeNode extends React.Component<ITreeNodeProps, never> {
    constructor(props: ITreeNodeProps, context?: any) {
        super(props, context);
    }

    public shouldComponentUpdate(nextProps: ITreeNodeProps): boolean {
        return !Immutable.is(nextProps, this.props);
    }

    private renderChildNode(childNode: TreeNode, index: number): JSX.Element {
        if (this.handleChildNodeSelection) {
            return (
                <li key={index} className={childNode.props.isSelected ? "active" : null}>
                    <a onClick={this.props.childClickTarget && this.handleChildNodeSelection.bind(this, childNode)}>{childNode.props.text}</a>
                </li>
            );
        }
        else {
            return (
                <li key={index}>
                    <a>{childNode.props.text}</a>
                </li>
            );
        }
    }

    public render(): JSX.Element {
        var self = this;
        var linkAnchor: JSX.Element;

        var className = "content";
        if (this.props.isExpanded) {
            className += " active";
        }
        if (self.props.childNodes) {
            // render child nodes
            var childGroup =
                (
                    <div id={self.props.componentId} className={className}>
                        <ul>
                            {self.props.childNodes.toArray().map(self.renderChildNode, self)}
                        </ul>
                    </div>
                );

            // render anchor link
            linkAnchor = (
                <a href={"#" + self.props.componentId} onClick={this.props.childClickTarget && this.handleParentNodeSelection.bind(this)}> {self.props.text} </a>
            );
        }
        return (

            <li key={self.props.componentId} className={self.props.className}>
                {linkAnchor}
                {childGroup}
            </li>
        );
    }

    public handleChildNodeSelection(childNode: TreeNode, event: React.MouseEvent): void {
        event.preventDefault();
        var operation = new LocalEvent(LocalOperations.Documents.Tree_SubClass_Selection);
        operation.AddItem("target", this.props.childClickTarget);
        operation.AddItem("parentId", this.props.componentId);
        operation.AddItem("childId", childNode.props.componentId);

        LocalEventDispatcher.dispatch(operation);
    }

    public handleParentNodeSelection(e: React.MouseEvent): void {
        e.preventDefault();
        // to implement when it's going to be needed
        var operation = new LocalEvent(this.props.parentClickOperation);
        operation.AddItem("value", this.props.lookupId);
        LocalEventDispatcher.dispatch(operation);
    }
}

export { ITreeNodeProps, TreeNode };
